<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const sectionPositions = ref([]);
const numberSections = ref(1);


const getSectionPositions = () => {
    const sections = document.querySelectorAll('section');
    sectionPositions.value = Array.from(sections).map(section => ({
        id: section.id,
        top: section.offsetTop,
        bottom: section.offsetTop + section.offsetHeight
    }));
}

const detectVisibleSection = () => {
    const scrollTop = window.scrollY;
    //   const viewportHeight = window.innerHeight;

    for (const section of sectionPositions.value) {
        if (scrollTop >= section.top && scrollTop <= section.bottom) {
            const visibleSection = document.querySelector(`#${section.id}`);
            const dataSection = visibleSection.getAttribute('data-section');
            numberSections.value = parseInt(dataSection, 10);

            // console.log(numberSections.value);
            //   console.log(`La sección ${section.id} con data-section ${dataSection} está visible en el viewport`);
            // Realiza las acciones que desees para esta sección
        }
    }
}

window.addEventListener('scroll', detectVisibleSection);

onMounted(() => {
    getSectionPositions();
});

onUnmounted(() => {
    window.removeEventListener('scroll', detectVisibleSection);
});

let repeat = [];
const scrollToSection = (num) => {
    let numSection = num;
    if (repeat[repeat.length - 1] === num) {
        numSection = num + 1;
    }
    repeat.push(numSection);
    const section = document.querySelector(`#section-${numSection}`);
    if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
    }
};
const smoothScroll = (num) => {
    let numSection = num;
    if (repeat[repeat.length - 1] === num) {
        numSection = num - 1;
    }
    repeat.push(numSection);
    const section = document.querySelector(`#section-${numSection}`);
    if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
    }
};


</script>
<template>

    <div class="button__floating flex gap-1 sm:gap-3">
        <button @click.prevent="smoothScroll(numberSections)" class="section"> <svg xmlns="http://www.w3.org/2000/svg"
                width="14.974" height="17.746" viewBox="0 0 14.974 17.746">
                <g id="Grupo_131" data-name="Grupo 131" transform="translate(-7430.874 -2098.879)">
                    <g id="Grupo_11" data-name="Grupo 11">
                        <g id="Grupo_10" data-name="Grupo 10">
                            <path id="Trazado_14" data-name="Trazado 14"
                                d="M7438.072,2098.959a.558.558,0,0,1,.576,0l6.8,3.744c.18.108.4.252.4.468v4.535c0,.288-.216.5-.4.4l-7.092-4.033-7.09,4.033c-.18.107-.4-.109-.4-.4v-4.535c0-.216.216-.36.4-.468Zm0,8.5a.556.556,0,0,1,.576,0l6.8,3.743c.18.109.4.252.4.469v4.535c0,.288-.216.5-.4.4l-7.092-4.031-7.09,4.031c-.18.108-.4-.108-.4-.4v-4.535c0-.217.216-.36.4-.469Z"
                                fill="#000" />
                        </g>
                    </g>
                </g>
            </svg></button>
        <button class="section flex" @click="scrollToSection(numberSections + 1)">
            <span class="mr-3 hidden font-bold sm:block">SIGUIENTE</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14.974" height="17.746" viewBox="0 0 14.974 17.746"
                class=" rotate-180">
                <g id="Grupo_131" data-name="Grupo 131" transform="translate(-7430.874 -2098.879)">
                    <g id="Grupo_11" data-name="Grupo 11">
                        <g id="Grupo_10" data-name="Grupo 10">
                            <path id="Trazado_14" data-name="Trazado 14"
                                d="M7438.072,2098.959a.558.558,0,0,1,.576,0l6.8,3.744c.18.108.4.252.4.468v4.535c0,.288-.216.5-.4.4l-7.092-4.033-7.09,4.033c-.18.107-.4-.109-.4-.4v-4.535c0-.216.216-.36.4-.468Zm0,8.5a.556.556,0,0,1,.576,0l6.8,3.743c.18.109.4.252.4.469v4.535c0,.288-.216.5-.4.4l-7.092-4.031-7.09,4.031c-.18.108-.4-.108-.4-.4v-4.535c0-.217.216-.36.4-.469Z"
                                fill="#000" />
                        </g>
                    </g>
                </g>
            </svg>
        </button>
    </div>

</template>
<style scoped>

.button__floating {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 40;
    color: #000;
    cursor: pointer;
    transition: background-color 0.3s;
}

.section {
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease;
    width: 100%;
    padding: 15px;
    background-color: #fff;
    border: 1px solid #000;
    border-radius: 4px;
}

.section:hover {
    background-color: #f0f0f0;
    color: #000;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Eliminado mix-blend-mode para mantener los colores consistentes */
</style>